import globalErrorHandler from '../utils/errorHandler.js';
import { _makeFetch, _toJson } from './_common.js';

function onError(error) {
  globalErrorHandler(error);
  throw error;
}

export function getAccountData() {
  return _makeFetch('/core/account/data', { credentials: 'include' })
    .then(_toJson)
    .catch(onError);
}
